<script setup lang="ts">
import { useGetCompanySettings } from "@/api/companies";
import { useDateFormat } from "../composables/useDateFormat";
import { ElLink } from "element-plus";
import { computed } from "vue";

const { data } = useGetCompanySettings();
const scheduledForDate = computed(() =>
  data.value?.upgrade?.scheduledAt
    ? new Date(data.value.upgrade.scheduledAt)
    : new Date()
);
const formattedDate = useDateFormat(scheduledForDate);
</script>
<template>
  <div class="banner">
    <i18n-t
      keypath="supgrade.scheduleConfirmedBanner"
      tag="p"
      scope="global"
    >
      <template #date>
        {{ formattedDate }}
        <el-link
          :underline="false"
          class="link"
          type="default"
          @click="$router.push('/upgrade/confirm')"
          >{{ $t("supgrade.findOutMore") }}
        </el-link>
      </template>
    </i18n-t>
  </div>
</template>
<style lang="scss" scoped>
.link {
  margin-left: 0.25rem;
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 0.25rem;
  &:hover {
    text-decoration: none;
  }
}
.banner {
  background: #1bbae1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  padding: 1rem;
  & p {
    font-weight: 600;
    color: white;
    font-size: 1rem;
  }
}
</style>
